import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { TreeView as TreeView$1 } from '@mui/lab';
import { Icon } from '../Icon/Icon.js';
var defaultProps = {
  defaultCollapseIcon: /*#__PURE__*/React.createElement(Icon, {
    icon: "ArrowDropDown"
  }),
  defaultExpandIcon: /*#__PURE__*/React.createElement(Icon, {
    icon: "ArrowRight"
  })
};
var TreeView = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TreeView$1, _extends({
    ref: ref
  }, defaultProps, props));
});
TreeView.displayName = 'TreeView';
export { TreeView };